<template>
  <div class="personalCenter">
    <div class="personInfo">
      <div class="personInfo-left">
        <div class="personInfo-left-photo">
          <svg-icon v-if="!personalInfo.faceImg" icon-class="avatar" />
          <img v-else :src="baseURL + personalInfo.faceImg" alt>
          <div class="personInfo-left-staff">{{ personalInfo.staff ? '员工' : '访客' }}</div>
        </div>
        <div class="personInfo-left-text">
          <p class="text-name" /><p class="text-name" @click="goPersonalData">
            {{ personalInfo.name }}
            <van-icon name="arrow" style="margin-left: 30px" />
          </p>
          <p class="text-tel">{{ personalInfo.phone }}</p>
          <p v-if="personalInfo.staff === true" class="text-com">{{ personalInfo.company }}</p>
        </div>
      </div>
      <div class="personInfo-right">
        <div v-if="personalInfo.staff === true && qrBtn" class="roundP" @click="openQrcodeOrTip">
          <span style="margin-right: 3px">
            <svg-icon icon-class="qrCode" />
          </span>
          通行码
        </div>
        <div v-if="personalInfo.staff === false" class="roundP" @click="staffValidation">员工认证</div>
      </div>
    </div>
    <div class="list">
      <div v-for="(item, index) in menuList" :key="index" class="myRecord">
        <div class="header">{{ item.name }}</div>
        <van-grid :column-num="4" :border="false">
          <van-grid-item v-for="(son, idx) in item.subMenus" :key="idx" @click="() => onRecord(son.icon)">
            <svg-icon :icon-class="`icon_${son.icon}`" class="icon" />
            <div class="name">
              {{ son.name }}
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <van-dialog v-model="showTipDialog" title="温馨提示" confirm-button-text="我知道了" class="tipDialog">
      <p class="diaCode">抱歉，您暂无通行二维码可生成</p>
      <div class="tips">
        <p>二维码生成条件</p>
        <p>1、您已被授予二维码点位通行权限；</p>
        <p>2、您已在后台录入IC卡号信息，IC卡号可虚拟。</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { Row, Col, Icon, Cell, CellGroup, Dialog } from 'vant';
import { GetUserInfo, VisitorUnbind, StaffUnbind, myBalance, getMenuList } from '@/api/user';
import { searchStaff } from '@/api/home';
import config from '@/common/config';
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      baseURL:
          process.env.NODE_ENV === 'development'
            ? config.baseUrl.dev
            : config.baseUrl.pro,
      personalInfo: {
        name: '',
        gender: '',
        phone: '',
        company: '',
        faceImg: '',
        idNumber: '',
        staff: false
      },
      balanceInfo: {},
      qrCodeImgUrl: '', // 二维码图片
      showTipDialog: false, // 没二维码的时候提示
      timestamp: new Date().getTime(),
      qrCode: '',
      staffValidationInfo: {}, // 员工认证信息
      menuList: [],
      qrBtn: true
    };
  },
  created() {
    this.getUserInfo();
    this.getMenu();
    // 判断下是不是员工
  },
  methods: {
    getMenu() {
      getMenuList({}).then((res) => {
        const { menus } = res.data;
        this.menuList = menus.filter(item => {
          return item.type === 'tag';
        });
        const btnList = menus.filter(item => {
          return item.type === 'button';
        });
        const btnPermission = [];
        btnList.forEach(item => {
          btnPermission.push(item.icon);
        });
        this.qrBtn = btnPermission.includes('qr');
      });
    },
    // 用户信息
    getUserInfo() {
      const data = {};
      GetUserInfo(data).then(response => {
        if (response.data) {
          this.personalInfo = response.data;
          this.qrCode = response.data.qr ? response.data.qr : '';
          localStorage.setItem(
            'personalInfo',
            JSON.stringify(this.personalInfo)
          );
          if (response.data.personType === 'STAFF') {
            this.getBalanceInfo();
          }
        } else {
          this.$router.push({ name: 'bind' });
        }
      });
    },
    getBalanceInfo() {
      myBalance({}).then(res => {
        this.balanceInfo = res.data;
      });
    },
    // 点击员工二维码图标
    openQrcodeOrTip() {
      // this.$toast.loading({
      //   message: '生成中...',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   duration: 0
      // });
      if (this.qrCode) {
        this.$toast.clear();
        this.$router.push({ name: 'passCode' });
      } else {
        this.showTipDialog = true;
        this.$toast.clear();
      }
    },
    goAttendance() {
      this.$router.push({ name: 'attendanceRecord' });
    },
    onRecord(e) {
      this.personalInfo = JSON.parse(localStorage.getItem('personalInfo') || '{}');
      switch (e) {
        case 'visitor':
          this.goHistory();
          break;
        case 'meeting':
          this.$router.push({ name: 'staffMeetingHistory' });
          break;
        case 'consumption':
          if (this.personalInfo.staff) {
            this.$router.push({ name: 'expensesRecord' });
          } else {
            this.$toast({
              message: '仅认证员工可查看消费记录'
            });
          }
          break;
        case 'more':
          this.goSetting();
          break;
        case 'attendance':
          if (this.personalInfo.staff) {
            this.goAttendance();
          } else {
            this.$toast({
              message: '仅认证员工可查看考勤记录'
            });
          }
          break;
        case 'bookMeeting':
          if (this.personalInfo.staff) {
            this.goMeetingBook();
          } else {
            this.$toast({
              message: '仅认证员工可使用会议预约'
            });
          }
          break;
        case 'bookMeal':
          if (this.personalInfo.staff) {
            if (this.balanceInfo.staffStatus === 'OPENNING') {
              this.goMealBook();
            } else {
              // this.$toast({
              //   message: '请先开通消费功能'
              // });
              this.goMealBook();
            }
          } else {
            this.$toast({
              message: '仅认证员工可使用消费订餐'
            });
          }
          break;
        case 'canteen':
          if (this.personalInfo.staff) {
            if (this.balanceInfo.staffStatus === 'OPENNING') {
              this.$router.push({ name: 'myAccount' });
            } else {
              // this.$toast({
              //   message: '请先开通消费功能'
              // });
              this.$router.push({ name: 'myAccount' });
            }
          } else {
            this.$toast({
              message: '仅认证员工可使用消费服务/卡券服务'
            });
          }
          break;
        case 'vouchers':
          if (this.personalInfo.staff) {
            if (this.balanceInfo.staffStatus === 'OPENNING') {
              this.$router.push({ name: 'vouchers' });
            } else {
              // this.$toast({
              //   message: '请先开通消费功能'
              // });
              this.$router.push({ name: 'vouchers' });
            }
          } else {
            this.$toast({
              message: '仅认证员工可使用消费服务/卡券服务'
            });
          }
          break;
        case 'elevator':
          this.$toast({
            message: '暂未开放'
          });
          break;

        default:
          break;
      }
    },
    // 员工认证
    staffValidation() {
      const data = {
        phone: this.personalInfo.phone
      };
      searchStaff(data).then(res => {
        if (res.code === 200) {
          sessionStorage.setItem('staffInfo', JSON.stringify(res.data));
          this.getUserInfo();
          this.$router.push({ name: 'match' });
        } else {
          this.$router.push({ name: 'unmatch' });
        }
      });
    },
    // 个人资料
    goPersonalData() {
      this.$router.push({ name: 'personalData' });
    },
    // 历史记录
    goHistory() {
      this.personalInfo = JSON.parse(
        localStorage.getItem('personalInfo') || '{}'
      );
      switch (this.personalInfo.staff) {
        case false:
          this.$router.push({ name: 'history' });
          break;
        case true:
          this.$router.push({ name: 'staffHistory' });
          break;
        default:
          break;
      }
    },
    unbind() {
      // this.showCancleDialog = true
      Dialog.confirm({
        title: '温馨提示',
        message: '解绑微信后将不能再使用访客功能，确认解绑？',
        messageAlign: 'left'
      })
        .then(() => {
          this.personalInfo = JSON.parse(
            localStorage.getItem('personalInfo') || '{}'
          );
          switch (this.personalInfo.staff) {
            case false:
              this.visitorUnbind();
              break;
            case true:
              this.staffUnbind();
              break;
            default:
              break;
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    // 访客解绑微信
    visitorUnbind() {
      const data = {};
      VisitorUnbind(data).then(response => {
        Cookies.set('token', '', -1, '/');
        Cookies.set('secret', '', -1, '/');
        localStorage.removeItem('personalInfo');
        this.$router.push({ name: 'bind' });
      });
    },
    // 员工解绑微信
    staffUnbind() {
      const data = {};
      StaffUnbind(data).then(response => {
        Cookies.set('token', '', -1, '/');
        Cookies.set('secret', '', -1, '/');
        localStorage.removeItem('personalInfo');
        this.$router.push({ name: 'bind' });
      });
    },
    goSetting() { // 点击设置
      this.$router.push({ name: 'systemSetting' });
    },
    goMeetingBook() { // 会议预约
      this.$router.push({ name: 'meetingBook' });
    },
    goMealBook() { // 订餐
      this.$router.push({ name: 'mealBook' });
    }
  }
};
</script>

<style lang="less" scoped>
.personalCenter {
  .personInfo {
    display: flex;
    flex: 1;
    background: #6994eb;
    //align-items: center;
    justify-content: space-between;
    padding: 0.18rem 0.15rem 0.5rem 0.15rem;
    //padding-bottom: 1rem;
    .personInfo-left {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .personInfo-left-photo {
        width: 0.68rem;
        height: 0.68rem;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .svg-icon {
          width: 100%;
          height: 100%;
        }
        .personInfo-left-staff {
          position: absolute;
          right: 0px;
          bottom: -3px;
          font-size: 9px;
          color: #ffffff;
          background: rgba(51, 51, 51, 0.7);
          border: 2px solid #FFFFFF;
          opacity: 1;
          border-radius: 27px;
          padding: 2px 5px;
        }
      }
      .personInfo-left-text {
        width: 1.4rem;
        margin-left: 0.055rem;
        .text-name {
          display: flex;
          align-items: center;
          font-size: 0.18rem;
          color: #ffffff;
          .gender {
            display: inline-block;
            margin-left: 0.14rem;
          }
        }
        .text-tel,
        .text-com {
          font-size: 0.14rem;
          color: rgba(51, 51, 51, 0.5);
          color: #ffffff;
          margin-bottom: 0.02rem;
        }
        .text-tel {
          color: #ffffff;
        }

      }
    }
    .personInfo-right {
      .roundP {
        width: 0.8rem;
        height: 0.27rem;
        line-height: 0.27rem;
        text-align: center;
        opacity: 1;
        border-radius: 27px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #6994eb;
        background-color: #ffffff;
      }
    }
  }
  .personalCenter-item {
    display: flex;
    justify-content: space-between;
    height: 0.48rem;
    line-height: 0.48rem;
    padding: 0rem 0.15rem 0rem 0.25rem;
    background: #fff;
    font-size: 0.17rem;
    box-sizing: content-box;
    .personalCenter-item-left {
      .svg-icon {
        height: 0.18rem;
        width: 0.21rem;
        margin-right: 0.24rem;
      }
    }
    &.hasBorderB {
      border-bottom: 1px solid #e5e5e5;
    }
    &.hasMarTop {
      margin-top: 0.1rem !important;
    }
  }
  .bigHeight{
    .qrcode {
      // width: 1.64rem;
      // height: 1.64rem;
      // margin: 0 auto;
      display: flex;
      justify-content: center;
      /deep/img {
        width: 100%;
        height: 100%;
      }
    }
    .van-button {
      display: flex;
      width: 0.95rem;
      height: 0.3rem;
      line-height: 0.3rem;
      text-align: center;
      margin: 0.25rem auto;
    }
    .tips {
      font-size: 0.12rem;
      color: #ffbe00;
      line-height: 0.18rem;
    }
  }
  .tipDialog{
    /deep/.van-dialog__content{
      padding:0;
      // text-align: center;
      .diaCode{
        color: #333;
        text-align: center;
        font-size: 0.18rem;
        line-height: 0.3rem;
        height: 0.3rem;
        margin: 0.25rem auto 0rem;
      }
      .tips{
        display: flex;
        flex-direction: column;
        text-align: left;
        font-size: 0.12rem;
        color: #ffbe00;
        line-height: 0.18rem;
        margin-left: 0.30rem;
        // margin-bottom: 0.03rem;
        margin-top: 0.15rem;
      }

    }

  }
  .list {
    margin: -30px 12px 0 12px;
    .myRecord {
      background-color: #ffffff;
      padding: 16px;
      margin-bottom: 20px;
      border: 1px solid #EFEFF4;
      box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
      opacity: 1;
      border-radius: 6px;

      .header {
        font-size: 0.18rem;
        color: #333333;
        font-weight: 400;
      }

      .icon {
        height: 0.5rem;
        width: 0.5rem;
      }
    }
  }
}

</style>
